import { render, staticRenderFns } from "./modal-newsletter.vue?vue&type=template&id=1c65f196&scoped=true"
import script from "./modal-newsletter.vue?vue&type=script&lang=js"
export * from "./modal-newsletter.vue?vue&type=script&lang=js"
import style0 from "./modal-newsletter.vue?vue&type=style&index=0&id=1c65f196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c65f196",
  null
  
)

export default component.exports